import { paymentSystem } from "./enums";

export const isFrame = window.self !== window.top;

//** Проверка есть-ли оплата по карте для компании */
export const getHasCompanyCard = company => company.paySbrf || company.payTinkoffCard || company.payCloudPayments;

//** Получить тип оплаты по карте для компании */
export const getCompanyCardPaymentSystem = company => {
    if (company.paySbrf) return paymentSystem.Sbrf;
    if (company.payTinkoffCard) return paymentSystem.TinkoffCard;
    if (company.payCloudPayments) return paymentSystem.CloudPayments;
    return null;
}

//** Если autopay == false то проверяет есть-ли оплата по карте для компании, иначе проверяет что оплата по карте == paymentSystem.TinkoffCard */
export const getCompanyCardAutopay = (company, autopay) => {
    if (!autopay) return getHasCompanyCard(company);
    return getCompanyCardPaymentSystem(company) === paymentSystem.TinkoffCard || getCompanyCardPaymentSystem(company) === paymentSystem.CloudPayments;
}